import React, { forwardRef, useCallback } from 'react';
import RangeSelector from '@polestar/component-warehouse-react/components/range-selector/RangeSelector';
import Orientations from '@polestar/component-warehouse-react/tokens/orientations/Orientations';
const Slider = forwardRef(({ onChange, onInput, min = 0, max = 100, value = 0, steps = 0, disabled = false, orientation = Orientations.horizontal, ...props }, ref) => {
    const handleChange = useCallback((values) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(values[1]);
    }, [onChange]);
    const handleInput = useCallback((values) => {
        onInput === null || onInput === void 0 ? void 0 : onInput(values[1]);
    }, [onInput]);
    return (React.createElement(RangeSelector, { ...props, ref: ref, onChange: handleChange, onInput: handleInput, min: min, max: max, value: [min, value], steps: steps, disabled: disabled, orientation: orientation, singleValue: true }));
});
Slider.displayName = 'Slider';
export default Slider;
